import api from './client'

export interface UserPreferences {
  voice_enabled: boolean | null
  video_enabled: boolean | null
  playback_rate: number | null
  therapist_preference: string | null
}

export async function getPreferences(): Promise<UserPreferences> {
  const response = await api.get('/user/preferences')
  return response.data
}

export async function updatePreferences(
  data: Partial<UserPreferences>
): Promise<void> {
  await api.put('/user/preferences', data)
}
